// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___30nLR","container_1":"container_1___34kqs","container_2":"container_2___11RRz","mask-wrapper":"mask-wrapper___2yPmp","mask-content-wrapper":"mask-content-wrapper___2tyAA","close-btn":"close-btn___1TMbB","play-btn":"play-btn___24k6k","catalog-content-wrapper":"catalog-content-wrapper___36dfq","carousel-image":"carousel-image___1uQLH"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/catalogues/styles.module.scss
// module id = 200
// module chunks = 0